import { FC, Fragment } from "react";

import { Flex } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import Link from "@components/Link";
import { Typography } from "@components/common";

import { isLvEnvironment } from "../utils/environment";

const footerWrapperStyle = {
  justifyContent: "center",
  alignItems: "center",
  flexWrap: "wrap",
  columnGap: "0.75rem",
  rowGap: "0.25rem",
  pt: "0.5rem",
  pb: "0.5rem",
};
const separatorStyle = { color: "gray.300" };

const CookieConsentFooter: FC = () => {
  const { t } = useTranslation();

  if (!isLvEnvironment()) {
    return null;
  }

  const links = [
    {
      id: "cookie-consent-footer-privacy",
      label: t("cookie_consent-footer-privacy_label"),
      href: t("cookie_consent-footer-privacy_href"),
    },
    {
      id: "cookie-consent-footer-imprint",
      label: t("cookie_consent-footer-imprint_label"),
      href: t("cookie_consent-footer-imprint_href"),
    },
  ];

  return (
    <Flex sx={footerWrapperStyle}>
      {links.map(({ id, label, href }, index) => (
        <Fragment key={id}>
          {index > 0 && (
            <Typography as="span" type="small" sx={separatorStyle}>
              |
            </Typography>
          )}
          <Link id={id} label={label} href={href} isExternal size="sm" variant="dark" />
        </Fragment>
      ))}
    </Flex>
  );
};

export default CookieConsentFooter;

